/* eslint-disable sonarjs/no-duplicate-string */
import { showCommentFileOption } from 'reactApp/appHelpers/featuresHelpers/features/showCommentFileOption';
import { type IAccessRightsOptions, type IPublicAccessRightsOptions, EAccessRights } from 'reactApp/components/SharingWindow/Sharing.types';
import { EPublicAccessRights } from 'reactApp/modules/weblinkAccessControl/weblinkAccessControl.types';

export const DELETE_USER: IAccessRightsOptions = {
    key: EAccessRights.DELETE_USER,
    text: 'Закрыть доступ',
    dropdownText: 'Закрыть доступ',
};

export const UNMOUNT_USER: IAccessRightsOptions = {
    key: EAccessRights.UNMOUNT_USER,
    text: 'Отключить доступ',
    dropdownText: 'Отключить доступ',
};

// TODO: когда уберем фича-флаг, сделать объектом
export const getAccessRightsOptions = (isFolder: boolean) => {
    const commonOptions = {
        [EAccessRights.READ_WRITE]: {
            key: EAccessRights.READ_WRITE,
            text: 'редактирование',
            dropdownText: 'Редактирование',
        },
        [EAccessRights.READ_ONLY]: {
            key: EAccessRights.READ_ONLY,
            text: 'просмотр',
            dropdownText: 'Только просмотр',
        },
    };

    if (showCommentFileOption && !isFolder) {
        return {
            [EAccessRights.COMMENT]: {
                key: EAccessRights.COMMENT,
                text: 'комментирование',
                dropdownText: 'Комментирование',
            },
            ...commonOptions,
        };
    }

    return commonOptions;
};

export const ACCESS_RIGHTS_OPTIONS_FOLDER_BIZ: Record<string, IAccessRightsOptions> = {
    [EAccessRights.READ_WRITE]: {
        key: EAccessRights.READ_WRITE,
        text: 'редактирование',
        dropdownText: 'Редактирование',
    },
    [EAccessRights.READ_ONLY]: {
        key: EAccessRights.READ_ONLY,
        text: 'просмотр',
        dropdownText: 'Просмотр',
    },
};

// TODO: когда уберем фича-флаг, сделать объектом
export const getPublicAccessRightsOptions = (isFolder?: boolean) => {
    const commonOptions = {
        [EPublicAccessRights.READ_WRITE]: {
            key: EPublicAccessRights.READ_WRITE,
            text: 'редактирование',
            dropdownText: 'Редактирование',
        },
        [EPublicAccessRights.READ_ONLY]: {
            key: EPublicAccessRights.READ_ONLY,
            text: 'просмотр',
            dropdownText: 'Только просмотр',
        },
    };

    if (showCommentFileOption && !isFolder) {
        return {
            [EAccessRights.COMMENT]: {
                key: EAccessRights.COMMENT,
                text: 'комментировать',
                dropdownText: 'Комментировать',
            },
            ...commonOptions,
        };
    }

    return commonOptions;
};

export const PUBLIC_ACCESS_RIGHTS_OPTIONS_FOLDER_BIZ: Record<string, IPublicAccessRightsOptions> = {
    [EPublicAccessRights.READ_WRITE]: {
        key: EPublicAccessRights.READ_WRITE,
        text: 'редактирование',
        dropdownText: 'Редактирование',
    },
    [EPublicAccessRights.READ_ONLY]: {
        key: EPublicAccessRights.READ_ONLY,
        text: 'просмотр',
        dropdownText: 'Просмотр',
    },
};
